import Vue from "vue";
import { Route, NavigationGuardNext } from "vue-router";
import store from "@/store";

export const requireAuth = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
): void => {
  if (store.getters["auth/isAuthenticated"]) {
    if (store.getters["loaded"]) {
      next();
    } else {
      next({
        path: "/splash",
        query: { redirect: to.fullPath },
        replace: true,
      });
    }
  } else {
    next({ path: "/dashboard", replace: true });
  }
};

export const redirectIfAuthenticated = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
): void => {
  if (store.getters["auth/isAuthenticated"]) {
    next({ path: "/dashboard", replace: true });
  } else {
    next();
  }
};
